import { twdClass } from "../../../constants/tailwind.constants";
import { INPUT_TEXT, BTN_CLS } from "../../../constants/var.constants";
import { getSheetInfo, getSheetColumns, getCards } from "../../../api/services";
import { processParamValues } from "../../../utils/common.utils";

import PagesGoogleParams from "../pages/PagesGoogleParams";
import { cloneDeep, find, merge } from "lodash";
import { toast } from "react-toastify";
import {Button} from "../../ui/com_ui";
import JSON_PageDesigns from "../../../jsons_pageDesigns";

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";


const PageData = ({ loc='popup', orig_blocks=[], updatePageProps=()=>{}, apply=()=>{} }) => {
 
  const [paramsList, setParamsList] = useState([]);
  const [columnNames, setColumnNames] = useState([]);
  const [columnData, setColumnData] = useState([]);

  const {
    pageInfo,
    pageConfig,
    projectData: { connections, project_id },
  } = useSelector((state) => state.studioDetails);
  
  const {blocks=[], settings={}} = pageInfo
  const {pageType='', connectionId='', googleSheetName='', sheetColumns=[], paramsValues=[]} = settings

  const connection = find(connections, [
    "connection_id",
    connectionId,
  ]);

  console.log("orig_blocks", orig_blocks)
  
  useEffect(() => {
    getGoogleSheetColumns(googleSheetName)
  }, []);

  const getGoogleSheetColumns = (sheet_name) => {
    const {
      connection_details: { spreadsheetId },
      connection_id,
    } = connection
    /*
    getSheetColumns({
      project_id,
      sheet_name,
      spreadsheetId,
      connectionId: connection_id,
      ranges: [`${sheet_name}!A1:Z4`],
    }).then((resp) => {
            if (resp.success) {
        console.log(resp.data)
        //setColumnNames(resp.data);
      }
    });*/
    getCards({
      project_id,
      sheetName:sheet_name,
      connectionId: connection_id,  
      pagination:{start:0, limit:5}     
    }).then((resp) => {      
      if (resp.success) { 
        console.log("resp.data", resp.data) 
        setColumnData(resp.data)      
        /*let rd=resp.data.map((r, ri)=>{
          let r_={...r}
          forEach(r, function(value, key) {
            if(value.length > 100) {
              let slice=value.slice(0, 100);
              //console.log("slice", key, slice);
              r_[key]=slice
            }
            //console.log("r", key, value);
            
          });
          return r_
        })
        
        setSettingsData(prev=>{
            return({...prev, cards_data:rd})
        })*/
      }
    });
  };
  console.log("settings", settings)


  
  const Alert = () => {
    return(
      <div className={twdClass('text-base bg-blue-100 p-2 rounded-lg mb-2')}>
        <div className={twdClass('font-semibold  mb-2')}>External data source is not configured. To enable dynamic content, please configure the page data source settings.</div>    
      </div>
    )
  }

  if(!googleSheetName){
    return <Alert/>
  }
  const TD = ({item, k}) => {
    //console.log("TD", k)
    let found=find(item, (v2, k2)=>{
      //console.log("item", k, k2, v2)
      return k==k2 ? true :false
    })
    if(found && found.length > 20) {
      let slice=found.slice(0, 20);
      //console.log("slice", key, slice);
      found=slice
    }
    //console.log("found", found)
    return(
      <td className={'pd_td'}>{found}</td>
    )
  }
  const Records = () => {
    const handleClick = (row) => {
      console.log("row", row)
      
      let textValue = JSON.stringify(orig_blocks)
      let pValues = processParamValues(textValue);
      pValues.forEach((item) => {
        let found = find(paramsValues, ({replaceTo, columnValue})=>{
          return replaceTo == `{{${item.value}}}`
        })   
        if(found && row[found.columnValue]) {
            let val = row[found.columnValue].replace(/\"/g, '\\$&')  
            console.log("pValue", val, found, item.value, row[found.columnValue], row)  
            textValue = textValue.split(item.key).join(`${val}`);
            //textValue = textValue.split(item.key).join(`{-{${row[item.value]}}-}`);
            //textValue = textValue.split(item.value).join(`${card_data[item.value]}`);                   
        }
      });
      //textValue=textValue.replaceAll( "{-{", "{{")
      //textValue=textValue.replaceAll( "}-}", "}}");
      textValue = JSON.parse(textValue)    
      apply(textValue)      
    }
    return(
      <div className={'pd_table_holder'}>
      <table  className={`pd_table ${twdClass('text-sm')}`}>
        <tr>
          <td className={'pd_td_head'}></td>
          {sheetColumns.map(({key, value})=>{            
            return(
              <td className={'pd_td_head'}>{value}</td>
            )
          })}
        </tr>        
        {columnData.map((item)=>{
          return(
            <tr className={'pd_tr'} onClick={()=>{handleClick(item)}}>
              <Button color="black" size='xs'>Preview</Button>
              {sheetColumns.map(({key, value})=>{                  
                //console.log("column", key, value)              
                return (<TD {...{item, k:key}} />)
              })}
            </tr>
            )
        })}
      </table>
      </div>
    )
  }
  const Message = () => {
    return(
      <div className={twdClass('text-base bg-blue-100 p-2 rounded-lg -mx-2 mb-2')}>
        <div className={twdClass('font-semibold  mb-2')}>Previewing Data Records</div>
        <div className={twdClass('text-sm mb-4')}>To see how your page will look with real data, you can preview individual data records. Here's how:</div>
        <div className={twdClass('opacity-75 mb-2 text-sm ml-2')}>
          <span className={twdClass('font-semibold')}>Click on a data record: </span> to preview it in the page template.
        </div>
        <div className={twdClass('opacity-75 mb-2  text-sm ml-2')}>
          <span className={twdClass('font-semibold')}>View the preview : </span> The page template will update to show the data from the selected record. You can see how the variables e.g. <span className={twdClass('font-semibold bg-green-100 border border-green-500 px-2 rounded-md')}>&#123;&#123;variable_name&#125;&#125;</span> are populated with the actual data.
        </div>
        <div className={twdClass('opacity-75 mb-2  text-sm ml-2')}>
          <span className={twdClass('font-semibold')}>Switch between records : </span> Click on different data records to preview how the page will look with different data.
        </div>
      </div>
    )
  }
  
  return (
    <div  className={twdClass("px-2 py-2 relative")} style={{}}>
      <style>{`
        .pd_table_holder {
          border:1px solid #dddddd;
          border-radius:10px;
          width:100%;
          overflow:auto;
          display: block;
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .pd_table{
          white-space: nowrap !important;
        }
        .pd_td_head {
          padding:4px 10px;
          border:1px solid #dddddd;
          background-color:#D3E3FD;
        }  
        .pd_tr {
          background-color:#fefefe;
        }  
        .pd_tr:hover {
          background-color:#D3E3FD;
        }      
        .pd_td {
          white-space:noswrap;
          border:1px solid #eeeeee;
          border-letf:1px solid #dddddd;
          border-right:1px solid #dddddd;
          padding:2px 10px;
          cursor:pointer;
        }       
      `}</style>    
      <Message/>
      <div className={twdClass("relative overflow-auto  -mx-2")}>       
        <Records />
      </div>        
    </div>
  );
};

export default PageData;